import { useEffect, useRef, useState } from 'react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
import { ConsentTemplateDataMissingError, fetchConsentTemplateJson } from './consent_template_library_fetch';
import { actorsFromResource, documentFromTemplateResource, sourceMetadataFromResource, } from '../consent_view/consent_template_configuration_view/consent_template_configuration.helpers';
/** Loads CONSENT_TEMPLATE JSON for the configuration view. Does not download the PDF. */
export const useConsentTemplateConfiguration = (documentId) => {
    const [state, setState] = useState({ status: 'idle' });
    const { get } = useApiClient(ApiClientService.LIBRARY);
    const getRef = useRef(get);
    getRef.current = get;
    useEffect(() => {
        if (!documentId) {
            setState({ status: 'idle' });
            return;
        }
        let cancelled = false;
        setState({ status: 'loading' });
        (async () => {
            try {
                const template = await fetchConsentTemplateJson(getRef.current, documentId);
                if (cancelled) {
                    return;
                }
                const data = template.data ?? {};
                const metadata = template.metadata ?? {};
                setState({
                    status: 'ready',
                    document: documentFromTemplateResource(template),
                    version: template.version,
                    source: sourceMetadataFromResource(data, metadata),
                    actors: actorsFromResource(template),
                });
            }
            catch (error) {
                if (cancelled) {
                    return;
                }
                const dataMissing = error instanceof ConsentTemplateDataMissingError;
                setState({
                    status: 'error',
                    dataMissing,
                    message: error instanceof Error ? error.message : 'Failed to load configuration.',
                });
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [documentId]);
    return state;
};
